import React from 'react';
import { isBrowser } from '@zapier/common-utils';
import { TrackPropsType } from './types';

export default class TrackEntry extends React.Component<TrackPropsType> {
  componentDidMount() {
    const { track, trackingMessage, trackingProps = {} } = this.props;

    if (isBrowser()) {
      const message = trackingMessage || 'track entry';
      track(message, { ...trackingProps });
    }
  }

  render() {
    return this.props.children;
  }
}
